var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      attrs: { id: "registration-form", autocomplete: "off" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          $event.stopPropagation()
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "form-page" },
        [
          _c(
            "div",
            { staticClass: "container-main" },
            [
              _c(
                "b-row",
                {
                  staticClass: "w-100 bg justify-content-center",
                  attrs: { "no-gutters": "" },
                },
                [
                  _c("b-col", { attrs: { cols: "10", lg: "7" } }, [
                    _c("h1", { staticClass: "main-title" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("account.registration.pageTitle")) +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "description" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t("account.registration.pageSubtitleClient")
                          ) +
                          "\n            "
                      ),
                      _c("br"),
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t("account.registration.alreadyHaveAnAccount")
                          ) +
                          "  \n            "
                      ),
                      _c("a", { attrs: { href: "#/login" } }, [
                        _vm._v(
                          _vm._s(_vm.$t("account.registration.loginHere"))
                        ),
                      ]),
                      _vm._v(".\n          "),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                {
                  staticClass: "justify-content-center",
                  attrs: { "no-gutters": "" },
                },
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "p-sm-5 px-3 card app-card",
                      attrs: { cols: "12", lg: "7" },
                    },
                    [
                      _c(
                        "b-row",
                        { attrs: { tag: "article" } },
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12", md: "4" } },
                            [
                              _c("material-input", {
                                attrs: {
                                  placeholder: _vm.$t("account.givenName"),
                                  label: _vm.$t("account.givenName"),
                                  "required-indicator": "",
                                },
                                model: {
                                  value: _vm.formData.givenName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "givenName", $$v)
                                  },
                                  expression: "formData.givenName",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: "12", md: "4" } },
                            [
                              _c("material-input", {
                                attrs: {
                                  placeholder: _vm.$t("account.middleName"),
                                  label: _vm.$t("account.middleName"),
                                },
                                model: {
                                  value: _vm.formData.middleName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "middleName", $$v)
                                  },
                                  expression: "formData.middleName",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: "12", md: "4" } },
                            [
                              _c("material-input", {
                                attrs: {
                                  placeholder: _vm.$t("account.familyName"),
                                  label: _vm.$t("account.familyName"),
                                  "required-indicator": "",
                                },
                                model: {
                                  value: _vm.formData.familyName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "familyName", $$v)
                                  },
                                  expression: "formData.familyName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { attrs: { tag: "article" } },
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("material-input", {
                                attrs: {
                                  value: _vm.formData.email,
                                  "custom-expression": "formatData.email",
                                  disabled: _vm.formData.isGhost,
                                  placeholder: _vm.$t("account.email"),
                                  label: _vm.$t("account.email"),
                                  "required-indicator": "",
                                  type: "email",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { attrs: { id: "phone-number", tag: "article" } },
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "material-input",
                                {
                                  attrs: {
                                    "on-type": "",
                                    label: _vm.$t("account.phoneNumber"),
                                    "required-indicator": "",
                                  },
                                  model: {
                                    value: _vm.formData.phoneNumber,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "phoneNumber", $$v)
                                    },
                                    expression: "formData.phoneNumber",
                                  },
                                },
                                [
                                  _c("phone-input", {
                                    staticClass:
                                      "material-input form-control form",
                                    attrs: {
                                      name: "phoneNoFill",
                                      pattern: ".{14,14}",
                                      placeholder: _vm.$t(
                                        "account.phoneNumber"
                                      ),
                                      type: "text",
                                      "data-lpignore": "true",
                                      "emit-value": "",
                                      value: _vm.formData.phoneNumber,
                                    },
                                    on: {
                                      change: function (val) {
                                        _vm.formData.phoneNumber = val
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { attrs: { id: "time-zone", tag: "article" } },
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("timezone-select", {
                                attrs: {
                                  timezone: _vm.formData.timezone,
                                  label: _vm.$t("account.timezoneQuestion"),
                                },
                                on: {
                                  "update:timezone": function ($event) {
                                    return _vm.$set(
                                      _vm.formData,
                                      "timezone",
                                      $event
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { attrs: { tag: "article" } },
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("password-input", {
                                attrs: {
                                  "validator-context": _vm.$v,
                                  password: _vm.formData.password,
                                  "custom-expression": "formData.password",
                                  disabled: _vm.loading,
                                  placeholder:
                                    "" +
                                    _vm.$t("account.password") +
                                    _vm.$t(
                                      "account.form.passwordLengthValidation"
                                    ),
                                  label: _vm.$t("account.password"),
                                  "required-indicator": "",
                                },
                                on: {
                                  "update:password": function ($event) {
                                    return _vm.$set(
                                      _vm.formData,
                                      "password",
                                      $event
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { attrs: { tag: "article" } },
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("material-input", {
                                attrs: {
                                  type: "password",
                                  placeholder: _vm.$t(
                                    "account.reEnterPassword"
                                  ),
                                  label: _vm.$t("account.reEnterPassword"),
                                  "required-indicator": "",
                                },
                                model: {
                                  value: _vm.formData.passwordRepeat,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "passwordRepeat",
                                      $$v
                                    )
                                  },
                                  expression: "formData.passwordRepeat",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "no-gutters justify-content-center" },
            [
              _c(
                "b-col",
                {
                  staticClass: "mb-sm-0 mb-3 text-center pretty-regular",
                  attrs: { cols: "11", lg: "6" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "required pretty p-icon p-smooth p-bigger",
                      staticStyle: {
                        "margin-top": "15px",
                        "margin-bottom": "20px",
                        "margin-right": "2px",
                      },
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.terms,
                            expression: "terms",
                          },
                        ],
                        staticClass: "checkbox",
                        attrs: { id: "terms", type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.terms)
                            ? _vm._i(_vm.terms, null) > -1
                            : _vm.terms,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.terms,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 && (_vm.terms = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.terms = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.terms = $$c
                            }
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "state p-primary" }, [
                        _c("i", { staticClass: "icon material-icons" }, [
                          _vm._v("done"),
                        ]),
                        _vm._v(" "),
                        _c("label", { staticClass: "grey-text" }, [
                          _vm._v(
                            _vm._s(_vm.$t("account.form.youAgreeTo")) +
                              "\n              "
                          ),
                          !_vm.isFrenchLanguage
                            ? _c("span", [_vm._v(" Expert Pro’s")])
                            : _vm._e(),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "terms clickable text-primary",
                      attrs: { href: _vm.TOS_EXTERNAL_LINK, target: "_blank" },
                    },
                    [_vm._v(_vm._s(_vm.$t("global.doorr.tos")))]
                  ),
                  _vm._v(" "),
                  _vm.isFrenchLanguage
                    ? _c("span", [
                        _vm._v(_vm._s(_vm.$t("account.form.ofExpertPro"))),
                      ])
                    : _vm._e(),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            {
              staticClass: "app-flow-buttons mt-3 justify-content-center",
              attrs: { "no-gutters": "" },
            },
            [
              _c(
                "b-col",
                { staticClass: "forward", attrs: { sm: "5" } },
                [
                  _c(
                    "simple-button",
                    {
                      attrs: {
                        disabled: _vm.$v.$invalid,
                        "class-name": "py-2 px-5 rounded-pill",
                        loading: _vm.loading,
                        "loading-succeeded": _vm.loadingStatus,
                      },
                      on: { click: _vm.handleSubmit },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("account.createAccount")) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }